import { Business } from '@material-ui/icons';
import Axios from '../axios-instance';
import { LOGIN_ENDPOINTS } from '../constants/GlobalConstants';

export const LoginAPI = {
  login: (user, password, isSupplier, isExternal) => {
    return Axios.post(LOGIN_ENDPOINTS.LOGIN, { Username: user, Password: password, Supplier: isSupplier, Type: isExternal }).then(({ data }) => data);
  },
  signUp: (cuit, email, isExternal) => {
    return Axios.post(LOGIN_ENDPOINTS.SIGN_UP, { Username: cuit, Email: email, Type: isExternal  }).then(({ data }) => data);
  },
  forgotPassword: (cuit, email, isExternal) => {
    return Axios.post(LOGIN_ENDPOINTS.FORGOT_PASSWORD, { Username: cuit, Email: email, Type: isExternal  }).then(({ data }) => data);
  },
  confirmSigningUp: (cuit, email, temporalToken, type) => {
    return Axios.post(LOGIN_ENDPOINTS.CONFIRM_SIGN_UP, { Username: cuit, Password: email, TokenId: temporalToken, Type: type }).then(
      ({ data }) => data
    );
  },
  changePassword: (cuit, email, temporalToken, type) => {
    return Axios.post(LOGIN_ENDPOINTS.CHANGE_PASSWORD, { Username: cuit, Password: email, TokenId: temporalToken, Type: type }).then(
      ({ data }) => data
    );
  },
  validateMFACode: (username, password, isSupplier, isExternal, codeMFA) => {
    return Axios.post(LOGIN_ENDPOINTS.VALIDATE_MFA_CODE, {Username: username, Password: password, Supplier: isSupplier, Type: isExternal, CodeMFA: codeMFA, BusinessName : ''}).then(({ data }) => data);
  },
  newMFACode: (username) => {
    return Axios.post(LOGIN_ENDPOINTS.NEW_MFA_CODE, {Username: username}).then(({ data }) => data);
  },
  Supplierlogin: (user, password, isSupplier, isExternal, supplierCuit) => {
    return Axios.post(LOGIN_ENDPOINTS.LOGIN, { Username: user, Password: password, Supplier: isSupplier, Type: isExternal, BusinessName: supplierCuit }).then(({ data }) => data);
  },
};
